export const AUTH_TEST_IDS = {
  createAccountLandingButton: 'auth-create-account-landing-button',
  existingAccountLandingButton: 'auth-existing-account-landing-button',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  passwordConfirmationInput: 'auth-password-confirmation-input',
  forgotPasswordButton: 'auth-forgot-password-button',
  submitButton: 'auth-submit-button',
  modeSwitchButton: 'auth-mode-switch-button',
} as const;
